import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function extendUserPage() {
  extend(UserPage.prototype, 'navItems', function (items) {
    var _this$user, _this$user2, _app$session$user, _this$user3;
    if ((_this$user = this.user) != null && _this$user.canHaveSignature() && ((_this$user2 = this.user) == null ? void 0 : _this$user2.id()) === ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) || (_this$user3 = this.user) != null && _this$user3.canEditSignature()) {
      var _this$user4;
      items.add('signature', m(LinkButton, {
        href: app.route('user.signature', {
          username: (_this$user4 = this.user) == null ? void 0 : _this$user4.slug()
        }),
        icon: "fas fa-signature"
      }, app.translator.trans('signature.forum.buttons.signature')), 20);
    }
  });
}